import { makeStyles } from '@material-ui/core/styles';

import { colors } from '../../tokens';

const useStyles = makeStyles(theme => ({
  clickableRow: {
    cursor: 'pointer',
    '&:hover': {
      background: '#fafafa',
    },
  },
  tableCell: {
    fontSize: 15,
    color: colors.textPrimary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  idCell: {
    display: 'flex',
    alignItems: 'center',
  },
  copyButton: {
    marginLeft: theme.spacing(1),
    padding: 4,
    flexShrink: 0,
  },
  copyIcon: {
    color: colors.textSecondary,
    fontSize: 18,
  },
  rowArrow: {
    color: colors.textSecondary,
    fontSize: 24,
  },
}));

export default useStyles;
